module.exports = "/_next/static/images/businessTeam-0971930f7c1e9b9b45ecbf7d82a75d5a.webp";